import { useAuth } from "@/context/auth-context";
import { isUserFullyVerified } from "@/lib/utils";
import UnverifiedHome from "../../components/pages/home/unverifiedHome";
import VerifiedHome from "../../components/pages/home/verifiedHome";

const HomeOverviewPage = () => {
	const { user } = useAuth();

	const isFullyVerified = isUserFullyVerified(user);

	return <>{isFullyVerified ? <VerifiedHome /> : <UnverifiedHome />}</>;
};

export default HomeOverviewPage;
